import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import UniversalUpdateAppAddForm from '../forms/UniversalUpdateAppAddForm'
import UniversalUpdateFilteringAppAddForm from '../forms/UniversalUpdateFilteringAppAddForm'
import UniversalUpdateEspressifAddForm from '../forms/UniversalUpdateEspressifAddForm'
import { addUniversalUpdateParameters, addUniversalUpdateReboot, addUniversalUpdateUnrent } from '../actions/universalupdates'
import '../styles/DashboardView.css'
import '../styles/UniversalUpdatesView.css'

const GENERAL_ACTIONS = [
  {
    key: 'reboot',
    label: 'Reiniciar Máquinas',
    shortDesc: 'Reboot global de todos los kioscos',
    icon: 'fas fa-power-off',
    btnClass: 'btn-reboot',
    confirmTitle: 'Reiniciar todas las máquinas',
    confirmDesc: 'Se enviará una señal de reboot a todos los kioscos conectados. Esta acción no puede deshacerse.',
    confirmIcon: '🔄',
  },
  {
    key: 'params',
    label: 'Enviar Parámetros',
    shortDesc: 'Sincroniza configuración en todas',
    icon: 'fas fa-sliders-h',
    btnClass: 'btn-params',
    confirmTitle: 'Enviar parámetros globales',
    confirmDesc: 'Se enviará la configuración de parámetros actualizada a todos los kioscos.',
    confirmIcon: '⚙️',
  },
  {
    key: 'unrent',
    label: 'Desalquilar Todo',
    shortDesc: 'Libera todos los lockers en uso',
    icon: 'fas fa-door-open',
    btnClass: 'btn-unrent',
    confirmTitle: 'Desalquilar todos los lockers',
    confirmDesc: 'Se liberarán todos los lockers actualmente en estado de alquiler. Los clientes perderán acceso inmediatamente.',
    confirmIcon: '⚠️',
  },
]

class UniversalUpdatesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 'selective',
      confirmAction: null,
      toasts: [],
    }

    this.updateReboot = this.updateReboot.bind(this)
    this.updateParameters = this.updateParameters.bind(this)
    this.updateUnrent = this.updateUnrent.bind(this)
    this.requestConfirm = this.requestConfirm.bind(this)
    this.executeConfirmed = this.executeConfirmed.bind(this)
    this.cancelConfirm = this.cancelConfirm.bind(this)
    this.addToast = this.addToast.bind(this)
  }

  addToast(message, type = 'success') {
    const id = Date.now()
    this.setState(s => ({ toasts: [...s.toasts, { id, message, type }] }))
    setTimeout(() => {
      this.setState(s => ({ toasts: s.toasts.filter(t => t.id !== id) }))
    }, 4000)
  }

  updateParameters() {
    return this.props.addUniversalUpdateParameters()
      .then(() => this.addToast('Parámetros enviados correctamente', 'success'))
      .catch(() => this.addToast('Error al enviar parámetros', 'error'))
  }

  updateReboot() {
    return this.props.addUniversalUpdateReboot()
      .then(() => this.addToast('Señal de reboot enviada', 'success'))
      .catch(() => this.addToast('Error al enviar reboot', 'error'))
  }

  updateUnrent() {
    return this.props.addUniversalUpdateUnrent()
      .then(() => this.addToast('Desalquiler global ejecutado', 'success'))
      .catch(() => this.addToast('Error en desalquiler global', 'error'))
  }

  requestConfirm(actionKey) {
    this.setState({ confirmAction: actionKey })
  }

  cancelConfirm() {
    this.setState({ confirmAction: null })
  }

  executeConfirmed() {
    const { confirmAction } = this.state
    this.setState({ confirmAction: null })
    if (confirmAction === 'reboot') this.updateReboot()
    else if (confirmAction === 'params') this.updateParameters()
    else if (confirmAction === 'unrent') this.updateUnrent()
  }

  render() {
    const { activeTab, confirmAction, toasts } = this.state
    const { role, type } = this.props
    const confirmMeta = confirmAction ? GENERAL_ACTIONS.find(a => a.key === confirmAction) : null

    if (role !== 'ADMIN' || type !== 'MASTER') {
      return (
        <div className="uv-wrapper">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 320, gap: 16 }}>
            <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(135deg, #991b1b 0%, #dc2626 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(220,38,38,0.3)' }}>
              <i className="fas fa-lock" style={{ color: '#fff', fontSize: 26 }}></i>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: '#1e293b', marginBottom: 6 }}>Acceso restringido</div>
              <div style={{ fontSize: 13, color: '#64748b', maxWidth: 320, lineHeight: 1.6 }}>
                Esta sección es exclusiva para administradores con perfil <strong>MASTER</strong>. No tienes permisos para acceder.
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="uv-wrapper">

        {/* ── Page Header ─────────────────────── */}
        <div className="dashboard-header mb-3">
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">
              <i className="fas fa-cloud-upload-alt"></i> Actualizaciones Universales
            </h1>
            <div className="small text-muted">Gestión centralizada de firmware, app y configuración de todos los kioscos</div>
          </div>
        </div>

        {/* ── Toasts ──────────────────────────── */}
        {toasts.map(t => (
          <div key={t.id} className={`uv-toast ${t.type}`}>
            <i className={`fas ${t.type === 'success' ? 'fa-check-circle' : t.type === 'error' ? 'fa-times-circle' : 'fa-info-circle'}`}></i>
            {t.message}
          </div>
        ))}

        {/* ── Tab Bar ─────────────────────────── */}
        <div className="uv-tab-bar">
          <button
            className={`uv-tab-btn tab-selective ${activeTab === 'selective' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'selective' })}
          >
            <i className="fas fa-filter"></i>
            Actualización Selectiva
            <span className="uv-tab-badge">1</span>
          </button>
          <button
            className={`uv-tab-btn tab-general ${activeTab === 'general' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'general' })}
          >
            <i className="fas fa-broadcast-tower"></i>
            Actualizaciones Generales
            <span className="uv-tab-badge">3</span>
          </button>
        </div>

        {/* ══ TAB: SELECTIVA ══════════════════════ */}
        {activeTab === 'selective' && (
          <div>
            <UniversalUpdateFilteringAppAddForm />
          </div>
        )}

        {/* ══ TAB: GENERALES ══════════════════════ */}
        {activeTab === 'general' && (
          <div>

            {/* App Kioscos */}
            <div className="uv-card">
              <div className="uv-card-header general">
                <i className="fas fa-mobile-alt"></i>
                Actualizar App — Todos los Kioscos
              </div>
              <div className="uv-card-body">
                <p style={{ color: '#475569', fontSize: 13, marginBottom: 16, lineHeight: 1.6 }}>
                  Introduce la URL de la APK y se desplegará la actualización en <strong>todos</strong> los kioscos registrados.
                </p>
                <UniversalUpdateAppAddForm />
              </div>
            </div>

            {/* Espressif */}
            <div className="uv-card">
              <div className="uv-card-header warning">
                <i className="fas fa-microchip"></i>
                Actualizar Firmware — Todos los Espressif
              </div>
              <div className="uv-card-body">
                <p style={{ color: '#475569', fontSize: 13, marginBottom: 16, lineHeight: 1.6 }}>
                  Lanza una actualización OTA del firmware Espressif en todos los lockers. Acción crítica — los lockers quedarán temporalmente fuera de servicio.
                </p>
                <UniversalUpdateEspressifAddForm />
              </div>
            </div>

            {/* Quick actions */}
            <div className="uv-card">
              <div className="uv-card-header danger">
                <i className="fas fa-bolt"></i>
                Acciones Rápidas Globales
              </div>
              <div className="uv-card-body">
                <p style={{ color: '#475569', fontSize: 13, marginBottom: 20, lineHeight: 1.6 }}>
                  Operaciones que afectan a <strong>todas</strong> las máquinas. Requieren confirmación antes de ejecutarse.
                </p>
                <div className="uv-quick-grid">
                  {GENERAL_ACTIONS.map(action => (
                    <button
                      key={action.key}
                      className={`uv-quick-btn ${action.btnClass}`}
                      onClick={() => this.requestConfirm(action.key)}
                    >
                      <i className={action.icon}></i>
                      {action.label}
                      <span className="uv-quick-desc">{action.shortDesc}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

          </div>
        )}

        {/* ── Confirm Overlay ─────────────────── */}
        {confirmMeta && (
          <div className="uv-confirm-overlay" onClick={this.cancelConfirm}>
            <div className="uv-confirm-box" onClick={e => e.stopPropagation()}>
              <div className="uv-confirm-icon">{confirmMeta.confirmIcon}</div>
              <div className="uv-confirm-title">{confirmMeta.confirmTitle}</div>
              <div className="uv-confirm-desc">{confirmMeta.confirmDesc}</div>
              <div className="uv-confirm-actions">
                <button className={`uv-confirm-yes ${confirmMeta.btnClass}`} onClick={this.executeConfirmed}>
                  <i className={`${confirmMeta.icon} mr-2`}></i>Confirmar
                </button>
                <button className="uv-confirm-cancel" onClick={this.cancelConfirm}>Cancelar</button>
              </div>
            </div>
          </div>
        )}

      </div>
    )
  }
}

const mapStateToProps = state => ({
  role: state.auth.role,
  type: state.auth.type,
})

const mapDispatchToProps = dispatch => ({
  addUniversalUpdateParameters: bindActionCreators(addUniversalUpdateParameters, dispatch),
  addUniversalUpdateReboot: bindActionCreators(addUniversalUpdateReboot, dispatch),
  addUniversalUpdateUnrent: bindActionCreators(addUniversalUpdateUnrent, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(UniversalUpdatesView)
